import { Badge, Card } from "@insights/ui";
import { Box } from "lucide-react";
import type { BuildDetail } from "../types/build";

type BuildInfoProps = {
  detail: BuildDetail;
};

export function BuildInfo({ detail }: BuildInfoProps) {
  const { artifacts, build, graph } = detail;

  return (
    <div className="build-info-modal-content">
      <div className="build-info-summary">
        <div>
          <span>{build.repository ?? "Build"}</span>
          <h3>{build.branch_or_tag}</h3>
        </div>
        <Badge
          tone={
            build.ended_at
              ? build.success
                ? "success"
                : "danger"
              : "warning"
          }
        >
          {build.ended_at
            ? build.success
              ? "Passed"
              : "Failed"
            : "Incomplete"}
        </Badge>
      </div>
      <div className="build-info-grid">
        <Card className="detail">
          <h3>Execution</h3>
          <dl>
            <dt>Environment</dt>
            <dd>{build.environment ?? "—"}</dd>
            <dt>Actor</dt>
            <dd>{build.actor_name ?? "Unknown"}</dd>
            <dt>Started</dt>
            <dd>{new Date(build.started_at).toLocaleString()}</dd>
            <dt>Completed</dt>
            <dd>
              {build.ended_at
                ? new Date(build.ended_at).toLocaleString()
                : "Not recorded"}
            </dd>
          </dl>
        </Card>
        <Card className="detail">
          <h3>
            Artifacts <Badge>{artifacts.length}</Badge>
          </h3>
          {artifacts.length ? (
            artifacts.map((artifact) => (
              <div className="artifact" key={artifact.id}>
                <Box />
                <div>
                  <strong>
                    {artifact.project} / {artifact.target}
                  </strong>
                  <span>
                    {artifact.size_bytes.toLocaleString()} bytes ·{" "}
                    {artifact.status}
                  </span>
                </div>
              </div>
            ))
          ) : (
            <p className="build-info-empty">No artifacts were recorded.</p>
          )}
        </Card>
        <Card className="json submitted-graph">
          <h3>Submitted graph</h3>
          <pre>{JSON.stringify(graph ?? {}, null, 2)}</pre>
        </Card>
      </div>
    </div>
  );
}
